export default __webpack_public_path__ + "static/media/tselogs.d0f7029b.jpeg";